import { initializeApp, getApps } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  signInWithRedirect,
  getRedirectResult,
} from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyDCsr6CAx8dc4ZPEyjCiC-L7rTYRcm-7QM",
    authDomain: "nomadic-pipe-462023-g9.firebaseapp.com",
    projectId: "nomadic-pipe-462023-g9",
    storageBucket: "nomadic-pipe-462023-g9.firebasestorage.app",
    messagingSenderId: "1061608592523",
    appId: "1:1061608592523:web:9df6a723762c936bacb08e",
    measurementId: "G-MZWLNHJVYP"
  };

export const getFirebaseApp = () => {
  if (!getApps().length) {
    initializeApp(firebaseConfig);
  }
  return getApps()[0];
};

export const getFirebaseAuth = () => getAuth(getFirebaseApp());

export {
  GoogleAuthProvider,
  signInWithPopup,
  signInWithRedirect,
  getRedirectResult,
};
